export interface NavigationMap {
  [key: string]: NavigationItem
}

export function generateNavigation(navigation: NavigationItem[]): NavigationItem[] {
  const navMap: NavigationMap = navigation.reduce((acc, navItem) => {
    acc[navItem.id] = { ...navItem, children: [] }
    return acc
  }, {} as NavigationMap)

  const nav = navigation.reduce((acc: NavigationItem[], navItem: NavigationItem) => {
    if (!acc) {
      acc = []
    }
    const item = navMap[navItem.id]
    if (!item)
      return acc
    if (!navItem.parent) {
      acc.push(normaliseRoutes(item))
    }
    else {
      const parent = navMap[navItem.parent]
      if (parent) {
        parent.children.push(normaliseRoutes(item))
      }
    }

    return acc
  }, [] as NavigationItem[])
  return nav
}
export function generateMenuFromNavigations(navigations: NavigationItem[][]) {
  if (!navigations?.length)
    return {}

  const navMap: NavigationMap = navigations.reduce((acc, navItem) => {
    acc[navItem.id] = { ...navItem, children: [] }
    return acc
  }, {} as NavigationMap)

  const nav = navigations.reduce((acc: Navigations, navItem: NavigationItem) => {
    const navType = navItem.navigationType
    if (!acc[navType]) {
      acc[navType] = []
    }
    const item = navMap[navItem.id]
    if (!item)
      return acc
    if (!navItem.parent) {
      acc[navType].push(normaliseRoutes(item))
    }
    else {
      const parent = navMap[navItem.parent]
      if (parent) {
        parent.children.push(normaliseRoutes(item))
      }
    }

    return acc
  }, {} as Navigations)

  return nav
}

function normaliseRoutes(route: NavigationItem) {
  if (route.expand?.page?.slug === 'homepage') {
    route.expand.page.slug = '/'
  }
  else if (route.expand?.page?.slug && !route.expand.page.slug.startsWith('/')) {
    route.expand.page.slug = `/${route.expand.page.slug}`
  }
  return route
}
